import en from './en';
import de from './de';
import ko from './ko';
import fa from './fa';
import ar from './ar';
import fr from './fr';
import es from './es';
import ja from './ja';
import vi from './vi';
import id from './id';
import zh from './zh';
import pt from './pt';

export default {
	en,
	de,
	ko,
	ja,
	fa,
	ar,
	fr,
	es,
	vi,
	id,
	zh,
	pt,
};
